import React, { Component, Fragment } from "react";
import MetaTags from "react-meta-tags";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import Content from "../sections/faq/Content";

class Faq extends Component {
  render() {
    return (
      <Fragment>
        <MetaTags>
          <title>Aglosi | FAQ's</title>
          <meta name="description" content="#" />
        </MetaTags>
        <Header />
        <Content />
        <Footer />
      </Fragment>
    );
  }
}

export default Faq;
